import React from 'react';
import * as PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import ClearIcon from "@material-ui/icons/Clear";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Fab from "@material-ui/core/Fab";

class LayoutDeleteButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenDialog: false,
        };

        this.closeDialog = this.closeDialog.bind(this);
        this.decideDelete = this.decideDelete.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    closeDialog() {
        this.setState({isOpenDialog: false});
    }

    decideDelete() {
        this.closeDialog();
        this.props.onClickDecide();
    }

    onClick() {
        this.setState({isOpenDialog: true});
    }

    render() {
        return (
            <div>
                <Fab
                    color="primary"
                    size="small"
                    className={this.props.className}
                    onClick={this.onClick}
                    disabled={this.props.layoutArrayLength === 1 || this.props.isDisabled}
                >
                    <ClearIcon/>
                </Fab>
                <Dialog open={this.state.isOpenDialog} onClose={this.closeDialog} style={{textAlign: "center"}}>
                    <DialogTitle>レイアウト削除の確認</DialogTitle>
                    <DialogContent>
                        <DialogContentText>現在のレイアウトを削除します。よろしいですか？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closeDialog} color="secondary" variant="contained">いいえ</Button>
                        <Button fullWidth onClick={this.decideDelete} color="primary" variant="contained">はい</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

LayoutDeleteButton.propTypes = {
    className: PropTypes.string,
    layoutArrayLength: PropTypes.number.isRequired,
    onClickDecide: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};

export default LayoutDeleteButton;
